import * as Yup from 'yup';

export const addNewGoalInitialValues = (selectedGoal) => {
  return {
    goalTitle: selectedGoal ? selectedGoal.goalTitle : '',
    goalDescription: selectedGoal ? selectedGoal.goalDescription : '',
    primaryPolicyId: selectedGoal ? selectedGoal.primaryPolicyId : '',
    secondaryPolicyId: selectedGoal ? selectedGoal.secondaryPolicyId : '',
  };
};

export const addNewGoalValidationSchema = (t) => Yup.object().shape({
  goalTitle: Yup.string()
    .required(t('formulary.validation.goal_required'))
    .max(250, t('formulary.validation.goal_should_be_less_than_250_characters')),
  primaryPolicyId: Yup.number().required(t('formulary.validation.primary_policy_required')),
});
